module.exports = __webpack_public_path__ + "img/star-light.274df83e.svg";